import * as React from 'react';
import { Box, IconButton, Stack } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import RestartAltIcon from '@mui/icons-material/RestartAlt';

const FAB_SX = {
    zIndex: 10,
    bgcolor: 'rgba(0,0,0,0.6)',
    color: 'white',
    opacity: { xs: 1, sm: 0 },
    transition: 'opacity 0.15s',
    '&:hover': { bgcolor: 'rgba(0,0,0,0.8)' },
};

export default function EditableSection({ label, onEdit, onRestore, restoreDisabled, children }) {
    return (
        <Box sx={{ position: 'relative', '&:hover .edit-section-fab': { opacity: 1 } }}>
            {children}
            <Stack direction="row" spacing={1} className="edit-section-fab" sx={{ position: 'absolute', top: 12, right: 12 }}>
                {onRestore && (
                    <IconButton
                        aria-label={`Restore ${label} to default`}
                        title={restoreDisabled ? 'No defaults saved yet' : undefined}
                        onClick={onRestore}
                        disabled={restoreDisabled}
                        sx={FAB_SX}
                    >
                        <RestartAltIcon fontSize="small" />
                    </IconButton>
                )}
                <IconButton aria-label={`Edit ${label}`} onClick={onEdit} sx={FAB_SX}>
                    <EditIcon fontSize="small" />
                </IconButton>
            </Stack>
        </Box>
    );
}
